export default "__VITE_ASSET__D4GFUr78__"